import React from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import '../../../../css/membershipList.css';
import DropdownIcon from '../../../../assets/icons/menu.png';
import MenuIcon from '../../../../materialUi/menuIcon';
import Btn from '../../../../materialUi/btn';
import Filter from './filter';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayFilter: false,
    };
  }

  handleDisplayFilter = () => {
    const { displayFilter } = this.state;
    const { resetFilters } = this.props;
    if (displayFilter) {
      this.setState({ displayFilter: false });
      // reset filter
      resetFilters('');
    } else {
      this.setState({ displayFilter: true });
    }
  };

  handleCreateNew = () => {
    sessionStorage.clear();
    this.props.history.push('/adminPortal/membership/register')
  }

  render() {
    const {
      selectedItems,
      handleExport,
      handleFilter,
      search,
      values,
      history,
    } = this.props;
    const { displayFilter } = this.state;
    const options = ['Download CSV', 'Print'];

    return (
      <Grid container className="root memberList-spacing">
        <Grid item xs={12} md={4} xl={6} className="memberList-header">
          Member List
        </Grid>
        <Grid item xs={12} md={8} xl={6}>
          <Grid container direction="row" justifyContent="flex-end" alignItems="center">
            <Grid className="memberList-btn-createNew">
              <Btn
                label="Create New"
                onClick={this.handleCreateNew}
                bgColor="#e76f50"
                color="white"
                bgColorHover="#ff8c68"
                colorHover="white"
                width={128}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs sm={2} lg={1} className="memberList-filter">
              <Box onClick={() => this.handleDisplayFilter()}>
                <img src={DropdownIcon} alt="Search Filter" />
                Filter
              </Box>
            </Grid>

            {/* filter for desktop  */}
            <Grid item xs className="memberList-box-selectedItems filter-desktop">
              {selectedItems}
            </Grid>

            <Grid item xs sm={1}>
              <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                <MenuIcon list={options} onClick={(value) => handleExport(value)} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* filter for mobile  */}
        <Grid container className="filter-mobile">
          <Grid item xs={12} className="memberList-box-selectedItems">
            {selectedItems}
          </Grid>
        </Grid>

        {displayFilter ? <Filter handleFilter={handleFilter} search={search} values={values} /> : ''}
      </Grid>
    );
  }
}

Header.propTypes = {
  resetFilters: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleExport: PropTypes.func.isRequired,
  handleFilter: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

export default withRouter(Header);
